import db from '../../versa/db.js';

function escapeHtml(s) {
	if (s == null) return '';
	const t = document.createElement('div');
	t.textContent = String(s);
	return t.innerHTML;
}

function toCsvValue(value) {
	const raw = value == null ? '' : String(value);
	return `"${raw.replace(/"/g, '""')}"`;
}

function buildStatsCsv(rows) {
	const headers = [
		'Empresa',
		'Cliente',
		'Pedido',
		'Referencia',
		'Transportador',
		'Programa',
		'% total de atendimento',
		'Posicoes atendidas',
		'Status',
		'Observacao reserva',
		'SKU',
		'Nome',
		'Lote Fabricante',
		'Unidade',
		'Solicitado',
		'Atendido',
		'%',
		'Posicao',
		'Embalagem sugerida',
	];
	const lines = [headers.map(toCsvValue).join(';')];
	for (const row of rows)
		lines.push(row.map(toCsvValue).join(';'));
	return '\ufeff' + lines.join('\n');
}

function downloadTextFile(content, filename, mimeType = 'text/csv;charset=utf-8') {
	const blob = new Blob([content], { type: mimeType });
	const url = URL.createObjectURL(blob);
	const a = document.createElement('a');
	a.href = url;
	a.download = filename;
	a.click();
	URL.revokeObjectURL(url);
}

export default async (results) =>		// { company_id: { order_id: { fulfillment, status, customer_nick, carrier_nick, program_name, items, positions_count }, ... } }
{
	if (!results || typeof results !== 'object')
		return '<p>Nenhum resultado disponível.</p>';

	/** 0% atendido = vermelho; parcial (<100%) = amarelo; 100% sem fundo. Pedido não aprovado = neutro. */
	function itemRowStyle(it) {
		if (!it || it.stock_evaluated === false)
			return 'background-color: #f3f4f6;';
		const ord = Number(it.quantity_ordered) || 0;
		const sup = Number(it.quantity_supplied) || 0;
		if (ord <= 0)
			return '';
		if (sup <= 0)
			return 'background-color: #fecaca;';
		const pct = Number(it.fulfillment_pct);
		if (Number.isFinite(pct) && pct < 100)
			return 'background-color: #fef08a;';
		return '';
	}

	const rows = [];
	const exportRows = [];
	for (const company_id of Object.keys(results)) {
		const company_nick = (await db.get('companies', company_id))?.nick ?? company_id;
		for (const order_id of Object.keys(results[company_id] || {})) {
			const rec = results[company_id][order_id];
			const items = rec?.items ?? [];
			const baseCols = [
				company_nick,
				rec?.customer_nick ?? '',
				order_id,
				rec?.reference ?? '',
				rec?.carrier_nick ?? '',
				rec?.program_name ?? '',
				rec?.fulfillment ?? 0,
				rec?.positions_count ?? 0,
				rec?.status ?? '',
				rec?.reservation_note ?? '',
			];
			if (items.length === 0) {
				exportRows.push([...baseCols, '', '', '', '', '', '', '', '', '']);
			}
			for (const it of items) {
				exportRows.push([
					...baseCols,
					it?.sku ?? '',
					it?.product_name ?? '',
					it?.lot_number ?? '',
					it?.unit_symbol ?? '',
					it?.quantity_ordered ?? 0,
					it?.quantity_supplied ?? 0,
					it?.fulfillment_pct ?? 0,
					it?.position ?? '',
					it?.packaging_plan ?? '',
				]);
			}
			rows.push(`
				<tr><td class="tal" colspan="2"><strong>${company_nick}</strong></td></tr>
				<tr><td class="tal" style="width: 140px;">Cliente</td><td class="tal">${escapeHtml(rec?.customer_nick ?? '')}</td></tr>
				<tr><td class="tal">Pedido</td><td class="tal">${order_id}</td></tr>
				<tr><td class="tal">Referência</td><td class="tal">${escapeHtml(rec?.reference ?? '')}</td></tr>
				<tr><td class="tal">Transportador</td><td class="tal">${escapeHtml(rec?.carrier_nick ?? '')}</td></tr>
				<tr><td class="tal">Programa</td><td class="tal">${escapeHtml(rec?.program_name ?? '')}</td></tr>
				<tr><td class="tal">% total de atendimento</td><td class="tal"><strong>${rec?.fulfillment ?? 0}%</strong></td></tr>
				<tr><td class="tal">Posições atendidas</td><td class="tal">${rec?.positions_count ?? 0}</td></tr>
				<tr><td class="tal" colspan="2" style="padding-top: var(--space-md);">${rec?.status ?? ''}</td></tr>
				${rec?.reservation_note ? `
				<tr><td class="tal" colspan="2" style="padding: var(--space-md); background: #fff7ed; border: 1px solid #fdba74; border-radius: 6px;">
					${escapeHtml(rec.reservation_note)}
				</td></tr>
				` : ''}
				${items.length > 0 ? `
				<tr><td colspan="2" style="padding-top: var(--space-sm);">
					<table class="stats-items" style="width: 100%; border-collapse: collapse; font-size: 0.9em;">
						<thead><tr>
							<th class="tal" style="border: 1px solid #ccc; padding: 4px 6px;">SKU</th>
							<th class="tal" style="border: 1px solid #ccc; padding: 4px 6px;">Nome</th>
							<th class="tal" style="border: 1px solid #ccc; padding: 4px 6px;">Lote Fabricante</th>
							<th class="tal" style="border: 1px solid #ccc; padding: 4px 6px;">Unidade</th>
							<th class="tar" style="border: 1px solid #ccc; padding: 4px 6px;">Solicitado</th>
							<th class="tar" style="border: 1px solid #ccc; padding: 4px 6px;">Atendido</th>
							<th class="tar" style="border: 1px solid #ccc; padding: 4px 6px;">%</th>
							<th class="tar" style="border: 1px solid #ccc; padding: 4px 6px;">Posição</th>
							<th class="tal" style="border: 1px solid #ccc; padding: 4px 6px;">Embalagem sugerida</th>
						</tr></thead>
						<tbody>
						${items.map(it => `
							<tr style="${itemRowStyle(it)}">
								<td class="tal" style="border: 1px solid #ccc; padding: 4px 6px;">${escapeHtml(it.sku)}</td>
								<td class="tal" style="border: 1px solid #ccc; padding: 4px 6px;">${escapeHtml(it.product_name)}</td>
								<td class="tal" style="border: 1px solid #ccc; padding: 4px 6px;">${escapeHtml(it.lot_number)}</td>
								<td class="tal" style="border: 1px solid #ccc; padding: 4px 6px;">${escapeHtml(it.unit_symbol)}</td>
								<td class="tar" style="border: 1px solid #ccc; padding: 4px 6px;">${it.quantity_ordered ?? 0}</td>
								<td class="tar" style="border: 1px solid #ccc; padding: 4px 6px;">${it.quantity_supplied ?? 0}</td>
								<td class="tar" style="border: 1px solid #ccc; padding: 4px 6px;">${it.fulfillment_pct ?? 0}%</td>
								<td class="tar" style="border: 1px solid #ccc; padding: 4px 6px;">${it.position ?? ''}</td>
								<td class="tal" style="border: 1px solid #ccc; padding: 4px 6px;">${escapeHtml(it.packaging_plan || '')}</td>
							</tr>
						`).join('')}
						</tbody>
					</table>
				</td></tr>
				` : ''}
			`);
		}
	}

	window.__sialExportOutputOrderStatsCsv = () => {
		const stamp = new Date().toISOString().slice(0, 19).replace(/[-:T]/g, '');
		const csv = buildStatsCsv(exportRows);
		downloadTextFile(csv, `geracao-saidas-resultados-${stamp}.csv`);
	};

	return `<style>
		#stats { width: 100%; border-collapse: collapse; }
		#stats td { padding: var(--space-sm); }
		.stats-items th, .stats-items td { font-weight: normal; }
		.stats-items tbody tr { transition: background-color 0.15s ease; }
		.stats-toolbar { display: flex; justify-content: flex-end; margin-bottom: 0.5rem; }
		.stats-toolbar button { padding: 0.35rem 0.6rem; }
	</style>
	<div class="stats-toolbar">
		<button type="button" class="button" onclick="window.__sialExportOutputOrderStatsCsv && window.__sialExportOutputOrderStatsCsv()">Exportar CSV</button>
	</div>
	<table id="stats">${rows.join('')}</table>`;
};
